
import WebService from "../../WebService"

const Attendee = {
    gets(params) {
        return WebService.get("/console/contest/attendees?" + params)
    },
    get(id, e = null) {
        return WebService.get("/console/contest/attendees/" + id + '?e=' + e)
    },
    create(data) {
        return WebService.post("/console/contest/attendees", data)
    },
    update(data) {
        return WebService.post("/console/contest/attendees/" + data.filter_id, data)
    },
}
export default Attendee